import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `ENGAGEMENT_*` codes the moderation queue meets.
 *
 * **Never inline a backend code in JSX.** The code is a log key; the sentence is
 * what reaches the operator, and the `X-Request-ID` is what they quote.
 *
 * `ENGAGEMENT_COMMENT_ALREADY_MODERATED` is the one an operator actually meets:
 * another operator decided the card between this page's load and the press. The
 * copy names the next step — the queue refetches and the card is gone — rather
 * than the collision, because there is nothing for this operator to do about it
 * and **no second notification is emitted**, which is a property of the server's
 * predicate guard rather than of the client's restraint.
 *
 * `ENGAGEMENT_REMOVAL_REASON_REQUIRED` is mapped to the dialog's field rather
 * than to a banner: the operator's words are still on screen and the dialog
 * stays open.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  ENGAGEMENT_FORBIDDEN: {
    message: 'مراجعة التعليقات تحتاج دور مشغّل في التفاعل، ولا يحمله حسابك.',
    tone: 'warning',
  },
  ENGAGEMENT_COMMENT_NOT_FOUND: {
    message: 'لم نعثر على هذا التعليق. قد يكون عولج بينما كانت الصفحة مفتوحة.',
    tone: 'warning',
  },
  ENGAGEMENT_COMMENT_ALREADY_MODERATED: {
    message: 'عولج هذا التعليق بالفعل. حُدّث الطابور.',
    tone: 'warning',
  },
  ENGAGEMENT_REMOVAL_REASON_REQUIRED: {
    message: 'اكتب سبب الرفض قبل الحسم.',
    tone: 'warning',
  },
  ENGAGEMENT_UPSTREAM_FAILED: {
    message: 'تعذّر جلب مواضيع التعليقات، والطابور بلا مواضيعه غير صالح للعمل. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
  ENGAGEMENT_UPSTREAM_TIMEOUT: {
    message: 'تأخّرت الخدمة عن الردّ. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
  ENGAGEMENT_RATE_LIMITED: {
    message: 'قرارات كثيرة في وقت قصير. انتظر قليلاً ثمّ أعد المحاولة.',
    tone: 'warning',
  },
};
